import type { CSSProperties } from "react";

import { EvidencePill } from "./EvidencePill.tsx";
import { PROVENANCE_LABELS } from "./provenance.constants.ts";
import type { TimelineRow } from "./provenance.model.ts";

/**
 * The chain read as a chain, under the list that builds it.
 *
 * Built from the same items in the same order as the entry list — one model
 * function each, over one array — so the summary cannot say something the rows
 * above it do not. Renders nothing at all when there is nothing to summarise: an
 * empty timeline is chrome claiming a record exists.
 */
export function ProvenanceTimeline({ rows }: { rows: TimelineRow[] }) {
  if (rows.length === 0) return null;

  return (
    <section className="provenance__timeline">
      <h3 className="provenance__subcard-title">{PROVENANCE_LABELS.timeline}</h3>

      <ol className="provenance__stops">
        {rows.map((row) => (
          <li
            key={row.id}
            className="provenance__stop"
            style={
              { "--grade": row.pill.token, "--grade-bg": row.pill.bgToken } as CSSProperties
            }
          >
            <span className="provenance__stop-mark" aria-hidden="true" />
            <span className="provenance__stop-owner">{row.ownerName}</span>
            <span className="provenance__stop-dates">{row.dates}</span>
            <span className="provenance__stop-sub">{row.subLine}</span>
            <span className="provenance__stop-marks">
              <EvidencePill pill={row.pill} />
              <span className="provenance__docs-count">{row.documentCount}</span>
              {row.attested !== null && (
                <span className="provenance__stop-attested">{row.attested}</span>
              )}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
